import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, LogOut, Phone } from 'lucide-react';
import TravelerLogin from './TravelerLogin';
import SosButton from './SosButton';
import { Alerts, Arrivals, Setup, Trips } from './TravelerParts';
import { K, clearSession, forgetDevice, tapi } from './tapi';

function useTravelerManifest() {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    const prev = link?.getAttribute('href');
    link?.setAttribute('href', '/manifest-traveler.json');
    document.title = 'BOND Viaggiatore';
    return () => { if (link && prev) link.setAttribute('href', prev); };
  }, []);
}

function Home({ onOut }) {
  const [me, setMe] = useState(null);
  const load = useCallback(() => tapi.get('/me').then((r) => setMe(r.data)).catch((e) => { if (e.response?.status === 401) onOut(); }), [onOut]);
  useEffect(() => { load(); const i = setInterval(load, 120000); return () => clearInterval(i); }, [load]);
  if (!me) return <Loader2 className="animate-spin text-[#D4AF37] mx-auto mt-20" />;
  return (
    <div className="space-y-4" data-testid="traveler-home">
      <p className="text-sm text-[#A3A3A3]">Ciao {me.trips[0]?.traveler || me.email}</p>
      <SosButton />
      <Setup me={me} reload={load} />
      <Arrivals items={me.arrivals} reload={load} />
      <Trips trips={me.trips} />
      <Alerts items={me.alerts} />
      <a href="tel:+390636225" className="flex items-center justify-center gap-2 text-sm text-[#D4AF37] py-2" data-testid="traveler-farnesina"><Phone size={15} />Unità di Crisi Farnesina · +39 06 36225 (h24)</a>
    </div>
  );
}

export default function TravelerApp() {
  useTravelerManifest();
  const [inside, setInside] = useState(() => !!localStorage.getItem(K.token));
  const hasSos = !!localStorage.getItem(K.sos);
  const out = useCallback(() => { clearSession(); setInside(false); }, []);
  const logout = () => { if (!window.confirm("Uscire? Il pulsante di emergenza funzionerà di nuovo solo dopo il prossimo accesso.")) return; tapi.post('/logout', null, { headers: { 'X-SOS-Token': localStorage.getItem(K.sos) || '' } }).catch(() => {}); forgetDevice(); setInside(false); };
  return (
    <div className="min-h-screen bg-[#050505] text-white" style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <header className="flex items-center justify-between px-5 h-16 border-b border-[#1A1A1A]">
        <img src="/assets/BOND_wordmark_gold.png" alt="BOND" className="h-7" />
        <span className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37]">Viaggiatore</span>
        {inside ? <button onClick={logout} aria-label="Esci" className="p-2 text-[#888]" data-testid="traveler-logout"><LogOut size={18} /></button> : <span className="w-8" />}
      </header>
      <main className="max-w-md mx-auto px-5 py-6">
        {inside ? <Home onOut={out} /> : (
          <div className="space-y-8">
            {hasSos && <SosButton />}
            <TravelerLogin onIn={() => setInside(true)} />
          </div>
        )}
      </main>
    </div>
  );
}
